(function () {
  var carouselMq =
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(min-width: 768px)')
      : null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function saveData() {
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return false;
    return !!(conn.saveData || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g');
  }

  function allowAutoplay() {
    return !prefersReducedMotion() && !saveData();
  }

  // Keep muted autoplay cheap: never decode more than this many clips at once.
  var MAX_AUTOPLAY = 3;

  function scrollStep(track) {
    var slide = track.querySelector('[data-amc-lc-slide]');
    if (!slide) return 0;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    return slide.offsetWidth + gap;
  }

  function getCardShell(slide) {
    return slide ? slide.querySelector('.amc-lc__card-shell') : null;
  }

  function prepareVideo(video) {
    if (!video) return;
    video.controls = false;
    video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function setShellState(slide, state) {
    var shell = getCardShell(slide);
    if (!shell) return;
    shell.classList.toggle('is-loading', state === 'loading');
    shell.classList.toggle('is-playing', state === 'playing');
    shell.classList.toggle('is-error', state === 'error');
    if (state === 'playing' || state === 'ready') shell.classList.add('has-frame');
    if (state !== 'error') {
      var note = shell.querySelector('[data-amc-lc-error]');
      if (note) note.hidden = true;
    }
  }

  function showVideoError(slide) {
    var shell = getCardShell(slide);
    setShellState(slide, 'error');
    if (!shell) return;
    var note = shell.querySelector('[data-amc-lc-error]');
    if (note) note.hidden = false;
  }

  function markHasFrame(slide) {
    var shell = getCardShell(slide);
    if (shell) shell.classList.add('has-frame');
  }

  function loadVideoSource(video) {
    if (!video) return false;
    if (video.dataset.amcLcLoaded === '1') return true;

    var attached = false;
    if (!video.getAttribute('src')) {
      var videoDataSrc = video.getAttribute('data-src');
      if (videoDataSrc) {
        video.setAttribute('src', videoDataSrc);
        attached = true;
      }
    }

    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      if (!sources[i].getAttribute('src')) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
        attached = true;
      }
    }

    if (!attached && !video.getAttribute('src') && !video.querySelector('source[src]')) {
      return false;
    }

    video.dataset.amcLcLoaded = '1';
    video.removeAttribute('data-amc-src-parked');
    if (attached) {
      try {
        video.load();
      } catch (err) {}
    }
    return true;
  }

  function paintFirstFrame(video) {
    if (!video || video.readyState < 2) return;
    if (video.currentTime > 0) return;
    try {
      video.currentTime = 0.05;
    } catch (err) {}
  }

  function whenVideoReady(video, onReady, onError) {
    if (!video) {
      if (onError) onError();
      return;
    }
    if (video.readyState >= 2) {
      onReady();
      return;
    }

    var settled = false;
    function finish(ok) {
      if (settled) return;
      settled = true;
      video.removeEventListener('canplay', onCanPlay);
      video.removeEventListener('loadeddata', onCanPlay);
      video.removeEventListener('error', onFail);
      if (ok) onReady();
      else if (onError) onError();
    }

    function onCanPlay() {
      finish(true);
    }
    function onFail() {
      finish(false);
    }

    video.addEventListener('canplay', onCanPlay);
    video.addEventListener('loadeddata', onCanPlay);
    video.addEventListener('error', onFail);
  }

  function playMuted(video, slide) {
    if (!video) return;
    prepareVideo(video);
    var attempt = video.play();
    if (!attempt || typeof attempt.then !== 'function') {
      setShellState(slide, video.paused ? 'ready' : 'playing');
      return;
    }
    attempt
      .then(function () {
        setShellState(slide, 'playing');
      })
      .catch(function () {
        paintFirstFrame(video);
        setShellState(slide, 'ready');
      });
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    try {
      video.pause();
    } catch (err) {}
  }

  function unmuteVideo(video) {
    if (!video) return;
    video.muted = false;
    video.defaultMuted = false;
    video.removeAttribute('muted');
  }

  function remuteVideo(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
  }

  function slideOverlap(slide) {
    if (!slide) return 0;
    var rect = slide.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    var vw = window.innerWidth || 0;
    var overlapY = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    var overlapX = Math.min(rect.right, vw) - Math.max(rect.left, 0);
    if (overlapY <= 0 || overlapX <= 0) return 0;
    return overlapY * overlapX;
  }

  function isSlideVisible(slide) {
    if (!slide) return false;
    var rect = slide.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    var vw = window.innerWidth || 0;
    var overlapY = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    var overlapX = Math.min(rect.right, vw) - Math.max(rect.left, 0);
    return overlapY > 64 && overlapX > 64;
  }

  function runQueue(items, limit, worker, done) {
    var index = 0;
    var active = 0;
    var stopped = false;

    function next() {
      if (stopped) return;
      if (index >= items.length && active === 0) {
        if (done) done();
        return;
      }
      while (active < limit && index < items.length) {
        active += 1;
        worker(items[index++], function () {
          active -= 1;
          next();
        });
      }
    }

    next();
    return function stop() {
      stopped = true;
    };
  }

  function activateSlide(slide, shouldPlay, done) {
    var video = slide.querySelector('.amc-lc__video');
    var youtube = slide.querySelector('[data-amc-lc-youtube]');

    if (youtube) {
      if (done) done();
      return;
    }

    if (!video) {
      if (done) done();
      return;
    }

    if (slide.dataset.amcLcActivating === '1') {
      if (done) done();
      return;
    }

    if (!loadVideoSource(video)) {
      showVideoError(slide);
      if (done) done();
      return;
    }

    if (video.readyState >= 2) {
      paintFirstFrame(video);
      markHasFrame(slide);
      if (shouldPlay && allowAutoplay()) playMuted(video, slide);
      else setShellState(slide, 'ready');
      if (done) done();
      return;
    }

    slide.dataset.amcLcActivating = '1';
    setShellState(slide, 'loading');

    whenVideoReady(
      video,
      function () {
        delete slide.dataset.amcLcActivating;
        paintFirstFrame(video);
        markHasFrame(slide);
        if (shouldPlay && allowAutoplay() && isSlideVisible(slide)) {
          playMuted(video, slide);
        } else {
          setShellState(slide, 'ready');
        }
        if (done) done();
      },
      function () {
        delete slide.dataset.amcLcActivating;
        showVideoError(slide);
        if (done) done();
      }
    );
  }

  function pauseSlideKeepFrame(slide) {
    if (!slide) return;
    var shell = getCardShell(slide);
    if (shell) shell.classList.remove('is-playing', 'is-loading');
    pauseVideo(slide.querySelector('.amc-lc__video'));
    pauseYouTube(slide.querySelector('[data-amc-lc-youtube]'));
    remuteVideo(slide.querySelector('.amc-lc__video'));
  }

  function syncVisible(section) {
    if (!section || section.dataset.amcLcActive !== '1') return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-amc-lc-slide]'));
    var visible = [];
    var hidden = [];

    slides.forEach(function (slide) {
      if (isSlideVisible(slide)) visible.push(slide);
      else hidden.push(slide);
    });

    hidden.forEach(pauseSlideKeepFrame);

    var canAutoplay = allowAutoplay();
    section.classList.toggle('is-autoplay', canAutoplay);

    visible.sort(function (a, b) {
      return slideOverlap(b) - slideOverlap(a);
    });

    var toPlay = canAutoplay ? visible.slice(0, MAX_AUTOPLAY) : [];
    var toWarm = visible.slice(toPlay.length).concat(hidden);

    if (section._amcLcQueueStop) section._amcLcQueueStop();
    section._amcLcQueueStop = runQueue(toPlay.concat(toWarm), 2, function (slide, next) {
      activateSlide(slide, toPlay.indexOf(slide) !== -1, next);
    });
  }

  function buildYouTubeEmbedUrl(videoId, loop) {
    if (!videoId) return '';

    var params = [
      'autoplay=1',
      'mute=1',
      'controls=0',
      'modestbranding=1',
      'playsinline=1',
      'rel=0',
      'iv_load_policy=3',
      'cc_load_policy=0',
      'disablekb=1',
      'fs=0',
      'autohide=1',
      'enablejsapi=1',
      'origin=' + encodeURIComponent(window.location.origin),
    ];

    if (loop) {
      params.push('loop=1');
      params.push('playlist=' + encodeURIComponent(videoId));
    }

    return (
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(videoId) +
      '?' +
      params.join('&')
    );
  }

  function loadYouTubeFrame(wrap) {
    if (!wrap || wrap.dataset.amcLcLoaded === '1') return;

    var iframe = wrap.querySelector('.amc-lc__youtube-frame');
    var videoId = wrap.dataset.youtubeId;
    if (!iframe || !videoId) return;

    iframe.src = buildYouTubeEmbedUrl(videoId, wrap.dataset.loop !== '0');
    wrap.dataset.amcLcLoaded = '1';
    wrap.classList.add('is-loaded');
  }

  function postYouTubeCommand(iframe, func, args) {
    if (!iframe || !iframe.contentWindow) return;

    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: func,
        args: args === undefined ? '' : args,
      }),
      '*'
    );
  }

  function unmuteYouTube(wrap) {
    if (!wrap || wrap.dataset.amcLcLoaded !== '1') return;
    var iframe = wrap.querySelector('.amc-lc__youtube-frame');
    postYouTubeCommand(iframe, 'unMute');
    postYouTubeCommand(iframe, 'setVolume', [100]);
  }

  function pauseYouTube(wrap) {
    if (!wrap || wrap.dataset.amcLcLoaded !== '1') return;
    var iframe = wrap.querySelector('.amc-lc__youtube-frame');
    postYouTubeCommand(iframe, 'pauseVideo');
  }

  function resumeYouTube(wrap) {
    if (!wrap || wrap.dataset.amcLcLoaded !== '1') return;
    var iframe = wrap.querySelector('.amc-lc__youtube-frame');
    postYouTubeCommand(iframe, 'playVideo');
  }

  function toggleSlidePlayback(section, slide) {
    if (!slide) return;

    var video = slide.querySelector('.amc-lc__video');
    var youtube = slide.querySelector('[data-amc-lc-youtube]');
    var shell = getCardShell(slide);

    section.querySelectorAll('[data-amc-lc-slide]').forEach(function (other) {
      if (other === slide) return;
      remuteVideo(other.querySelector('.amc-lc__video'));
    });

    if (youtube) {
      if (youtube.dataset.amcLcLoaded === '1') {
        resumeYouTube(youtube);
        unmuteYouTube(youtube);
        setShellState(slide, 'playing');
      } else {
        loadYouTubeFrame(youtube);
        setShellState(slide, 'playing');
      }
      return;
    }

    if (!video) return;

    if (!loadVideoSource(video)) {
      showVideoError(slide);
      return;
    }

    if (video.paused) {
      playMuted(video, slide);
      whenVideoReady(
        video,
        function () {
          unmuteVideo(video);
          var replay = video.play();
          if (replay && typeof replay.catch === 'function') replay.catch(function () {});
        },
        function () {
          showVideoError(slide);
        }
      );
      return;
    }

    if (video.muted) {
      unmuteVideo(video);
      if (shell) shell.classList.add('is-unmuted');
      return;
    }

    remuteVideo(video);
    if (shell) shell.classList.remove('is-unmuted');
  }

  function initPlayButtons(section) {
    section.querySelectorAll('[data-amc-lc-play-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleSlidePlayback(section, btn.closest('[data-amc-lc-slide]'));
      });
    });

    section.querySelectorAll('.amc-lc__card-shell').forEach(function (shell) {
      shell.addEventListener('click', function (e) {
        if (e.target.closest('[data-amc-lc-play-btn]')) return;

        var card = shell.querySelector('.amc-lc__card');
        if (card && card.tagName === 'A' && card.getAttribute('href')) return;

        var slide = shell.closest('[data-amc-lc-slide]');
        if (!slide) return;

        e.preventDefault();
        e.stopPropagation();
        toggleSlidePlayback(section, slide);
      });
    });

    section.querySelectorAll('.amc-lc__video').forEach(function (video) {
      video.addEventListener('playing', function () {
        setShellState(video.closest('[data-amc-lc-slide]'), 'playing');
      });
      video.addEventListener('waiting', function () {
        if (!video.paused && !video.ended) {
          setShellState(video.closest('[data-amc-lc-slide]'), 'loading');
        }
      });
    });
  }

  function initCarousel(root, onScroll) {
    if (!root || root.dataset.amcLcInit === '1') return null;
    if (carouselMq && !carouselMq.matches) return null;

    var track = root.querySelector('[data-amc-lc-track]');
    var prev = root.querySelector('[data-amc-lc-prev]');
    var next = root.querySelector('[data-amc-lc-next]');
    if (!track) return null;

    root.dataset.amcLcInit = '1';

    function canScroll() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    function updateNav() {
      var scrollable = canScroll();
      var maxScroll = track.scrollWidth - track.clientWidth - 1;

      if (prev) {
        var prevDisabled = !scrollable || track.scrollLeft <= 1;
        prev.disabled = prevDisabled;
        prev.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
      }
      if (next) {
        var nextDisabled = !scrollable || track.scrollLeft >= maxScroll;
        next.disabled = nextDisabled;
        next.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
      }
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: scrollStep(track) * dir, behavior: 'smooth' });
    }

    function onPrevClick() {
      scrollByDir(-1);
    }

    function onNextClick() {
      scrollByDir(1);
    }

    var scrollTimer;
    function onTrackScroll() {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        updateNav();
        if (onScroll) onScroll();
      }, 80);
    }

    function onResize() {
      updateNav();
    }

    if (prev) prev.addEventListener('click', onPrevClick);
    if (next) next.addEventListener('click', onNextClick);
    track.addEventListener('scroll', onTrackScroll, { passive: true });
    window.addEventListener('resize', onResize);
    updateNav();

    return function teardownCarousel() {
      window.clearTimeout(scrollTimer);
      if (prev) prev.removeEventListener('click', onPrevClick);
      if (next) next.removeEventListener('click', onNextClick);
      track.removeEventListener('scroll', onTrackScroll);
      window.removeEventListener('resize', onResize);
    };
  }

  function initSection(section) {
    if (!section || section.dataset.amcLcSectionInit === '1') return;
    section.dataset.amcLcSectionInit = '1';

    var carousel = section.querySelector('[data-amc-lc-carousel]');
    if (carousel) {
      carousel._amcLcCarouselTeardown = initCarousel(carousel, function () {
        syncVisible(section);
      });
    }

    section.querySelectorAll('.amc-lc__video').forEach(function (video) {
      prepareVideo(video);
      video.preload = 'none';
    });
    initPlayButtons(section);

    function activateSection() {
      section.dataset.amcLcActive = '1';
      syncVisible(section);
    }

    function deactivateSection() {
      section.dataset.amcLcActive = '0';
      if (section._amcLcQueueStop) section._amcLcQueueStop();
      section.querySelectorAll('[data-amc-lc-slide]').forEach(pauseSlideKeepFrame);
    }

    if (section.dataset.amcLcDesignMode === 'true') {
      activateSection();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      activateSection();
      return;
    }

    var sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activateSection();
          else deactivateSection();
        });
      },
      {
        root: null,
        rootMargin: '640px 0px',
        threshold: 0,
      }
    );

    sectionObserver.observe(section);
    section._amcLcObserver = sectionObserver;
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.amc-lc').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    event.target.querySelectorAll('[data-amc-lc-carousel]').forEach(function (el) {
      if (typeof el._amcLcCarouselTeardown === 'function') {
        el._amcLcCarouselTeardown();
        delete el._amcLcCarouselTeardown;
      }
      delete el.dataset.amcLcInit;
    });

    event.target.querySelectorAll('.amc-lc').forEach(function (el) {
      if (el._amcLcObserver) {
        el._amcLcObserver.disconnect();
        delete el._amcLcObserver;
      }
      delete el.dataset.amcLcSectionInit;
      delete el.dataset.amcLcActive;
    });

    boot(event.target);
  });
})();
